
// Vue / Vuex
import { Component, Vue, Prop } from "vue-property-decorator";


// Bulk Import Types
import { VueBootstrapField } from '@/store/types';

import BulkImport, {
    BulkType,
    ValidationStatus
} from '@/bulk-import/BulkImport';

@Component
export default class BulkImportValidationIcon extends Vue {
    @Prop({ default: null, type: Object, required: true }) row: { field: VueBootstrapField[], item: any, };

    @Prop({ default: () => ({}), type: Object, required: true }) serverSideValidation: Object;

    @Prop({ default: 0, type: Number, required: true }) submissionAttempts: number;

    @Prop({ default: () => [], type: Array, required: true }) submittedIds: number[];

    @Prop({ default: () => [], type: Array, required: true }) metaData: BulkImport[];

    @Prop({ default: null, type: Object, required: true }) v: any;

    private validationStatus: typeof ValidationStatus = ValidationStatus;

    /**
     * @summary Method which returns the the current validation state
     * for the row which is passed within the argument/s.
     */

    private findEachIndexById(id: number): number {
        if (!this.v) return -1;
        let index = -1;

        for (const [key, value] of Object.entries(this.v.data.$each)) {
            if((value as any)?.$model?.id == id) {
                index = +key;
            }
        }
        return index;
    }

    /**
     * @summary Method to get client side error messages
     */
    private clientValiationErrors(id: number): string[] {
        const index = this.findEachIndexById(id);

        if (index == -1) {
            return [];
        }
        const validationMessages: string[] = [];
        for (const [key, _] of Object.entries(this.v.data.$each[index])) {
            if (this.v.data.$each[index][key].$invalid) {
                const metaData = this.metaData.find(x => x.displayProperty == key);
                validationMessages.push(`${metaData?.header ?? key} is invalid`);
            }
        }
        return validationMessages;
    }

    private get invalidStatus(): number {
        if (!this.row?.item) {
            return ValidationStatus.NotSubmittable;
        }

        const id = this.row.item.id;
        const index = this.findEachIndexById(id);

        if (index == -1 || !this.v.data.$each[index]) {
            return ValidationStatus.NotSubmittable;
        }

        for (const [key, _] of Object.entries(this.v.data.$each[index])) {
            if (this.v.data.$each[index][key].$invalid) {
                return ValidationStatus.ClientValidationError;
            }
        }

        if (this.submissionAttempts > 0 && this.serverSideValidation[id]) {
            return ValidationStatus.ServerValidationError;
        } else if (this.submissionAttempts && !this.serverSideValidation[id] && this.submittedIds.includes(id)) {
            return ValidationStatus.ValidatedByServer;
        } else {
            return ValidationStatus.NotSubmittable;
        }
    }
}
